import React, { cloneElement, Fragment } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Button from "../../../../../../../common/Button";
import Tooltip from "./Tooltip";
import { TYPE } from "../../../../../../../../constant";
import { useUserInfo } from "../../../../../../../../hooks";
import clsx from "clsx";

const SubmitButtons = ( props ) => {

  const answeringQuestions = useSelector( state => state.answeringQuestions );
  const keypad = useSelector( state => state.keypad );
  const notepad = useSelector( state => state.notepad );

  const { t } = useTranslation();
  const { info } = useUserInfo();

  const {
    children,
    ...PROPS
  } = props;

  const isDisabled = ! answeringQuestions.isNextQuestion || notepad.isOverStroke || notepad?.isEditing

  return (
    <table summary="키패드">
      <tbody>
      <tr>
        <td className="left">
          { cloneElement( children || <Fragment />, { ...PROPS } ) }
        </td>
        <td className="grading">
          <Button className={clsx('btn', 'btn-blue', isDisabled && 'btn-gray')} disabled={ isDisabled } onClick={ props.onAnswering }>{ t( 'LC_05_20.msg008' ) }</Button>
        </td>
        {
          info.channelCode !== TYPE.CHANNEL.GLOBAL01 && (
            <td className="arr_area">
              <Button className="lr_arr blue" onClick={ props.onPrevCursor }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_lc_answermove_back.svg` } alt="" /></Button>
              <Button className="lr_arr blue" onClick={ props.onNextCursor }><img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_lc_answermove_next.svg` } alt="" /></Button>
                {!!keypad.arrowKeyTooltipStatus && <Tooltip fadeTooltip={props.fadeTooltip} /> }
            </td>
          )
        }
      </tr>
      </tbody>
    </table>
  );

};

export default SubmitButtons;
